export { hasAllVariables } from './has-all-variables';
export { isValidGql } from './is-valid-gql';
export { isClientOperation } from './is-client-operation';
export { createApolloClient } from './create-apollo-client';

export { booleanAttr, effect, gqlDocument, writable } from './descriptors';

export { applyPrototype } from './prototypes';
